import script from "./YouPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./YouPage.vue?vue&type=script&setup=true&lang=ts"

import "./YouPage.vue?vue&type=style&index=0&id=6e1f6ad0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6e1f6ad0"]])

export default __exports__